import {api} from '../../api/access-ctrl'
import {registerConfig} from '../../../components/common/di-ding'
import {commonConfig, routeNameOfDi} from '../common'
import {spDateFormat} from '../../../utils/util'
import inputDateHelper from '../../../components/common/inputs/_input-date-helper'

const mapping = {
  personName: {
    label: '姓名'
  },
  phone: {
    label: '手机号'
  },
  enterpriseName: {
    label: '所属住户'
  },
  deviceName: {
    label: '门禁'
  },
  openType: {
    label: '开门类型',
    mapList: {
      map: {
        '1': '二维码开门',
        '2': '密码开门 ',
        '3': '按钮开门',
        '4': '刷卡开门',
        '5': '人脸开门',
        '6': '远程开门'
      }
    }
  },
  snapUrl: {
    label: '人脸抓拍',
    type: 'personImg'
  },
  passType: {
    label: '进出类型',
    mapList: {
      map: {
        '1': '进',
        '2': '出 ',
        '3': '进/出'
      }
    }
  },
  openTime: {
    label: '开门时间',
    onDataLoaded (data) {
      data.createTime = data.createTime.slice(0, 19)
    }
  }
}

const config = {
  breadcrumb: [{
    value: '智慧门禁',
    name: 'accessCtrlDeviceManagementCenter'
  }, {
    value: '开门记录',
  }],
  center: {
    opBar: [ // 多少个元素代表多少行
      [ // 仅支持 flex布局
        {
          type: 'date-second',
          pickerOptions: {
            shortcuts: [
              inputDateHelper.OPTIONS.SHORTCUT.A_WEEK,
              inputDateHelper.OPTIONS.SHORTCUT.A_MONTH,
              inputDateHelper.OPTIONS.SHORTCUT.THREE_MONTHS
            ],
            disabledDate: inputDateHelper.OPTIONS.DISABLED_DATE.HENCEFORTH
          },
          default: inputDateHelper.time.todayRange,
          beforeDataIsGet ({requestBody}) {
            const [startTime, endTime] = inputDateHelper.time.todayRange()
            requestBody.startTime = spDateFormat(startTime)
            requestBody.endTime = spDateFormat(endTime)
          },
          entityInSearchRequestBody: (currentTime) => ({
            startTime: currentTime[0]||'',
            endTime: currentTime[1]||''
          })
        },
        [
          {type: 'input-search', label: '姓名/手机号', searchKey: 'searchKey'},
          {
            type: 'button-download',
            label: '导出',
            getDownloadUrl: (requestBody) => api.exportSwingCardRecord(requestBody),
            download: '开门记录'
          }
        ]
      ],
      [
        {
          type: 'search-device-tree',
          label: '门禁',
          searchKey: 'deviceCode',
          fetchDetail: () => api.getDeviceTreeList()
            .then(list => {
              list.forEach(it => {
                it._value = it.code
                it._label = it.name
              })
              return list
            })
        },
        {
          type: 'search-selector',
          label: '开门类型',
          searchKey: 'openType',
          fetchDetail: () => Promise.resolve(
            [{
              '_value': '1',
              '_label': '二维码开门'
            }, {
              '_value': '2',
              '_label': '密码开门'
            }, {
              '_value': '3',
              '_label': '按钮开门'
            }, {
              '_value': '4',
              '_label': '刷卡开门'
            }, {
              '_value': '5',
              '_label': '人脸开门'
            }, {
              '_value': '6',
              '_label': '远程开门'
            }]
          )
        },
        {
          type: 'search-selector',
          label: '进出类型',
          searchKey: 'carAccessType',
          fetchDetail: () => Promise.resolve(
            [{
              '_value': '0',
              '_label': '进场'
            }, {
              '_value': '1',
              '_label': '出场'
            }]
          )
        }
      ]
    ],
    table: {
      operations: []
    }
  },

  get: requestBody => api.getSwingCardRecordPage(requestBody),

  mapping
}

registerConfig(routeNameOfDi.APP_CENTER_ACCESS_CTRL_OPEN_RECORD, config)



// WEBPACK FOOTER //
// ./src/view/AccessCtrl/open-record/open-record.js